var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoviewarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Movie - warning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.79289 2.79289C2.98043 2.60536 3.23478 2.5 3.5 2.5H4.5V4.5H2.5V3.5C2.5 3.23478 2.60536 2.98043 2.79289 2.79289ZM3.5 1.5H5H11H12.5C13.0304 1.5 13.5391 1.71071 13.9142 2.08579C14.2893 2.46086 14.5 2.96957 14.5 3.5V5V8V8.3739C13.9372 8.13323 13.3175 8 12.6667 8C11.8846 8 11.1475 8.19238 10.5 8.5324V8.5H5.5V11V13.5H8.07419C8.13698 13.8483 8.23841 14.1832 8.3739 14.5H5H3.5C2.96957 14.5 2.46086 14.2893 2.08579 13.9142C1.71071 13.5391 1.5 13.0304 1.5 12.5V11V8V5V3.5C1.5 2.96957 1.71071 2.46086 2.08579 2.08579C2.46086 1.71071 2.96957 1.5 3.5 1.5ZM5.5 5V2.5H10.5V5V7.5H5.5V5ZM13.5 3.5V4.5H11.5V2.5H12.5C12.7652 2.5 13.0196 2.60536 13.2071 2.79289C13.3946 2.98043 13.5 3.23478 13.5 3.5ZM11.5 7.5V5.5H13.5V7.5H11.5ZM2.5 12.5V11.5H4.5V13.5H3.5C3.23478 13.5 2.98043 13.3946 2.79289 13.2071C2.60536 13.0196 2.5 12.7652 2.5 12.5ZM4.5 10.5H2.5V8.5H4.5V10.5ZM4.5 7.5H2.5V5.5H4.5V7.5Z",
    fill: "#566376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.6654 11.1852V12.6667M12.6654 14.1482H12.6691M15.9987 12.6667C15.9987 14.5077 14.5063 16 12.6654 16C10.8244 16 9.33203 14.5077 9.33203 12.6667C9.33203 10.8258 10.8244 9.33337 12.6654 9.33337C14.5063 9.33337 15.9987 10.8258 15.9987 12.6667Z",
    stroke: "#DE6868",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoviewarning);
export default __webpack_public_path__ + "static/media/moviewarning.838628045b7066ef8332c24f6c44b7bc.svg";
export { ForwardRef as ReactComponent };